import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import type VisitComposite from 'garaje/models/visit-composite';
import type { VisitStatus } from 'garaje/models/visit-composite';

interface Status {
  label: string;
  svg?: string;
}

interface StatusCellSignature {
  Args: {
    row: VisitComposite;
  };
}

const STATUSES: Record<VisitStatus, Status> = {
  no_show: { label: 'No show' },
  pre_registered: { label: 'Pre-registered' },
  invited: { label: 'Invited' },
  on_site: { label: 'Signed in' },
  signed_out: { label: 'Signed out' },
};

export default class StatusCell extends Component<StatusCellSignature> {
  get status(): Status {
    const { status } = this.args.row;
    return STATUSES[status] || { label: '' };
  }

  <template>
    <div class="flex flex-col" data-test-status-cell>
      <div class="flex items-center gap-2">
        {{#if this.status.svg}}
          {{svgJar this.status.svg height="14" width="14"}}
        {{/if}}
        <span data-test-status-label>{{this.status.label}}</span>
      </div>
    </div>
  </template>
}
